import Cookies from 'universal-cookie'

export const clearCookies = () => {
  const domain = process.env.REACT_APP_DOMAIN || '.adnexio.jobs'
  const cookies = new Cookies()
  cookies.remove('access_token', { path: '/', domain: domain })
  cookies.remove('hr_access_token', { path: '/', domain: domain })
  cookies.remove('token_expired', { path: '/', domain: domain })
}
